import React from 'react';
export function EmotionalTransition() {
  const scrollToCompra = () => {
    const el = document.getElementById('compra');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FEF3E2]" data-id="element-39">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-40">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3C1518] mb-6" data-id="element-41">
          Por eso creamos esta guía práctica.
        </h2>
        <p className="text-lg md:text-xl text-[#5C2D0E] leading-relaxed" data-id="element-42">
          Un recetario diseñado para que cualquier persona pueda preparar tortas
          caseras perfectas desde el primer intento, incluso si nunca horneó
          antes.
        </p>

        <div className="pt-8" data-id="element-43">
          <button onClick={scrollToCompra} className="w-full md:w-auto py-4 px-8 bg-[#EA580C] hover:bg-[#C2410C] text-white text-xl font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg" data-id="element-44">
            ¡Quiero dejar de fallar en mis tortas!
          </button>
        </div>
      </div>
    </section>;
}